import { render, staticRenderFns } from "./AnomaliesOrigins.vue?vue&type=template&id=03fe31d2&"
import script from "./AnomaliesOrigins.vue?vue&type=script&lang=js&"
export * from "./AnomaliesOrigins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports